<div class="main-padding">
  <h3 class="header-bottom header-text1">{{ 'SALECOMPANY_LIST.TITLE' | translate }}</h3>
  <div class="card-body">
    <p class="left-border header-text2">
      {{ 'SALECOMPANY_LIST.TITLE_DETAILS_CONTRACT' | translate }}
    </p>
  </div>
  <section class="content">
    <!-- App date -->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
          <h3 class="card-title">
            {{ 'SALECOMPANY_LIST.APP_DATE' | translate }}
          </h3>
        </div>
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-meaning">
          <div class="col-12">
            <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
              <h3 class="card-title long-text">{{ App_Date }}</h3>
             
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Start date -->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
          <h3 class="card-title">
            {{ 'SALECOMPANY_LIST.CONTRACT_START_DATE' | translate }}
          </h3>
        </div>
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-meaning">
          <div class="col-12">
            <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
              <h3 class="card-title long-text">{{ Start_Date }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Date -->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
          <h3 class="card-title">
            {{ 'SALECOMPANY_LIST.CONTRACT_END_DATE' | translate }}
          </h3>
        </div>
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-meaning">
          <div class="col-12">
            <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
              <h3 class="card-title long-text">{{ End_Date }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 1 -->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
          <h3 class="card-title">
            {{ 'DETAILS.BEFORE_DEST' | translate }}/{{
              'DETAILS.AFTER_DEST' | translate
            }}
          </h3>
        </div>
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-meaning">
          <div class="col-12">
            <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
              <h3 class="card-title" *ngIf="Corporate_Status == '1'">
                {{ 'DETAILS.BEFORE_DEST' | translate }}
              </h3>
              <h3 class="card-title" *ngIf="Corporate_Status == '2'">
                {{ 'DETAILS.AFTER_DEST' | translate }}
              </h3>
              <h3 class="card-title long-text" *ngIf="Corporate_Status == '3'">
                {{ 'DETAILS.OTHERS_DEST' | translate }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 2 -->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
          <h3 class="card-title">
            {{ 'DETAILS.COMPANY_NAME_DEST' | translate }}
          </h3>
        </div>
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-meaning">
          <div class="col-12">
            <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
              <h3 class="card-title long-text">{{ Company_Name }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest"></div>
        <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-meaning">
          <div class="col-12">
            <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
              <h3 style="margin-top: -25px" class="card-title long-text">
                {{ Company_Name_Kana }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 3 -->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
          <h3 class="card-title">{{ 'DETAILS.ADDRESS_DEST' | translate }}</h3>
        </div>
        <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-meaning">
          <div class="col-12">
            <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
              <h3 class="card-title">
                {{ Post_Code }}<br />{{ Address_1 }}<br />
                {{ Address_2 }}{{ Address_3 }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 4 -->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
          <h3 class="card-title">{{ 'DETAILS.TELEPHONE_DEST' | translate }}</h3>
        </div>
        <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-meaning">
          <div class="col-12">
            <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
              <h3 class="card-title">{{ TelePhone }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 5 -->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
          <h3 class="card-title">{{ 'SALECOMPANY_LIST.EMAIL' | translate }}</h3>
        </div>
        <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-meaning">
          <div class="col-12">
            <div class="col-12 col-sm-8 col-md-8 col-lg- col-xl-8">
              <div class="d-flex">
                <h3 class="card-title">{{Email}}</h3>
                
              </div>
            </div>
          </div>
        </div>
        <div>
          <button (click)="openPopup()" class="btn-popup" *ngIf="wf_salecompany_contract_detail">
            {{ 'COMMON.MAIL_POPUP_BUTTON' | translate }}
          </button>
        </div>
      </div>
       <!-- NewEmail Popup -->
          <div *ngIf="isPopupVisible" class="popup-overlay">
            <div class="popup-container">
              <div class="popup-header">
                <span class="popup-title">{{ 'MAIL_ADDRESS.CHANGE_MAIL_ADDRESS' | translate }}</span>
                <span class="popup-close" (click)="closePopup()">×</span>
              </div>
              <div class="popup-underline"></div>
  
              <p class="popup-text">
                {{ 'MAIL_ADDRESS.SEND_YOU_EMAIL_WITHURL_MSG' | translate }}<br>
                {{ 'MAIL_ADDRESS.ENTER_EMAIL_PRESS_SEND_MSG' | translate }}
              </p>  
              <div class="popup-input-group">
                <div class="input-group-append">
                <div class="input-group-text">
                  <span class="mail nav-icon ls"></span>
                </div>
              </div>
                <input
                  type="email"
                  class="popup-input"
                  name="New_Mail"
                  [(ngModel)]="New_Mail"
                  placeholder="{{ 'CONTRACTED_COMPANY_DETAIL.MAIL_ADDRESS' | translate }}"
                />
              </div>
              <div class="text-center">
            <div class="col-12">
              <div class="text1 text-center">
                <p id="error" style="height: 12px"></p>
              </div>
            </div>
             <div class="popup-actions">
                <button class="btn-cancel" (click)="closePopup()">{{ 'COMMON.COMMON_CANCEL_BUTTON' | translate }}</button>
                <button class="btn-send" (click)="change()">{{ 'COMMON.COMMON_SEND_BUTTON' | translate }}</button>
              </div>
          </div>  
            </div>
          </div>
          <!-- Confirm popup -->
          <!-- <div class="popup-overlay" *ngIf="isConfirmNewEmailPopupVisible">
            <div class="popup-container">
              <div class="popup-header">
                <span class="popup-close" (click)="isConfirmNewEmailPopupVisible = false">×</span>
              </div>
              <div class="text-center logo-top">
                <div class="login-logo">
                  <i class="confirm"></i>
                </div>
                <div class="text-center">
                  <p class="error-text-black" [innerHTML]="errorText"></p>
                </div>
              </div>
            </div>
          </div> -->
          <div class="popup-overlay" *ngIf="isConfirmNewEmailPopupVisible">
            <div class="popup-container">
              <div class="popup-header">
                <span class="popup-title">{{ 'MAIL_ADDRESS.CHANGE_MAIL_ADDRESS_CONFIRM' | translate }}</span>
                <span class="popup-close" (click)="isConfirmNewEmailPopupVisible = false">×</span>
              </div>
              <div class="popup-underline"></div>
              <div class="text-center logo-top">
                <div class="text-center">
                  <p class="error-text-black" [innerHTML]="errorText"></p>
                </div>
              </div>
              <div class="popup-actions">
                <button class="btn-cancel" (click)="isConfirmNewEmailPopupVisible = false">{{ 'COMMON.COMMON_CLOSE' | translate }}</button>
              </div>
            </div>
          </div>

    </div>
    <!-- 6 -->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
          <h3 class="card-title">{{ 'DETAILS.BUSINESS_TYPE_DEST' | translate }}</h3>
        </div>
        <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-confirm">
          <div class="col-12">
            <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-12">
              <h3 class="card-title">{{Business_Type_Name}}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 7 -->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
          <h3 class="card-title">{{ 'DETAILS.CHARGER_DEST' | translate }}</h3>
        </div>
        <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-meaning">
          <div class="col-12">
            <div class="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 display">
              <h3 class="card-title display">{{ Last_Name }}</h3>
              <h3 class="card-title" style="padding-left: 18px">{{ Name }}</h3>
            </div>
          </div>
          <div class="col-12">
            <div class="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 display">
              <h3 class="card-title display">{{ Last_Name_Kana }}</h3>
              <h3 class="card-title" style="padding-left: 18px">
                {{ Name_Kana }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>

      <!--staff position  -->
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
            <h3 class="card-title">{{ 'SALECOMPANY_LIST.STAFF_POSITION' | translate }}</h3>
          </div>
          <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-meaning">
            <div class="col-12">
              <div class="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 display">
                <h3 class="card-title display">{{Staff_Post}}{{ Staff_Position }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
       <!-- Number_Off_Employees -->
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
            <h3 class="card-title">{{ 'SALECOMPANY_LIST.NUMBER_OFF_EMPLOYEES' | translate }}</h3>
          </div>
          <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-meaning">
            <div class="col-12">
              <div class="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 display">
                <h3 class="card-title display">{{Number_Off_Employees }}</h3>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    <!-- 8 -->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
          <h3 class="card-title">{{ 'SALECOMPANY_LIST.USAGE' | translate }}</h3>
        </div>
        <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-meaning">
          <div class="col-12">
            <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
              <h3 class="card-title" *ngIf="Corporation_Form == '1'">
                {{ 'CONTRACT.CONTRACTED_COMPANY_EMPLOYEE' | translate }}
              </h3>
              <h3 class="card-title" *ngIf="Corporation_Form == '2'">
                {{ 'CONTRACT.HEALTH_INSURANCE' | translate }}
              </h3>
              <h3 class="card-title" *ngIf="Corporation_Form == '3'">
                {{ 'CONTRACT.WELFARE_AGENCY' | translate }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 9 -->

    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
          <h3 class="card-title">{{ 'SALECOMPANY_LIST.REGISTRATION_COPY' | translate }}</h3>
        </div>
        <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-meaning">
          <div class="col-12">
            <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
              <a class="btn-pink pdf-text" (click)="pdf_download()">
                {{ 'DETAILS.REGISTRATION_COPY_PDF_BUTTON' | translate }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 10 -->

    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
          <h3 class="card-title">{{ 'SALECOMPANY_LIST.ACQUIRED_NAME' | translate }}</h3>
        </div>
        <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-meaning">
          <div class="col-12">
            <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
              <h3 class="card-title">{{Acquired_Company_Name}}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center">
      <div class="col-12">
        <div class="display">
          <a (click)="openPopupReEmail()"  class="btn-pink"
          *ngIf="wf_salecompany_contract_detail">{{
              'CONTRACTED_COMPANY_DETAIL.EXAMINATION_RESULT_RESEND' | translate
            }}
          </a>
        </div>
      </div>
    </div>
    <!-- ReEmail Popup -->
    <div *ngIf="isPopupVisibleReEmail" class="popup-overlay">
      <div class="popup-container">
        <div class="popup-header">
          <span class="popup-title">{{ 'SALECOMPANY_LIST.EMAIL_RE_HEADER_TEXT' | translate }}</span>

          
          <span class="popup-close" (click)="closePopupReEmail()">×</span>
        </div>
        <div class="popup-underline"></div>

        <p class="popup-text">
          {{ 'SALECOMPANY_LIST.EMAIL_RE_BODY_TEXT_1' | translate }}<br>
          {{ 'SALECOMPANY_LIST.EMAIL_RE_BODY_TEXT_2' | translate }}
        </p>  
        <div class="d-flex align-items-center justify-content-center">
          <!-- <h3 class="card-title">{{ 'CONTRACTED_COMPANY_DETAIL.MAIL_ADDRESS' | translate }}</h3> -->
          <h3 class="card-title"> {{Email}}</h3>
        </div>
       
          <!-- <input
            type="email"
            class="popup-input"
            name="New_Mail"
            [(ngModel)]="New_Mail"
            placeholder="{{ 'CONTRACTED_COMPANY_DETAIL.MAIL_ADDRESS' | translate }}"
          /> -->
        <div class="text-center">
      <div class="col-12">
        <div class="text1 text-center">
          <p id="error" style="height: 12px"></p>
        </div>
      </div>
       <div class="popup-actions">
          <button class="btn-cancel" (click)="closePopupReEmail()">{{ 'COMMON.COMMON_CANCEL_BUTTON' | translate }}</button>
          <button class="btn-send" (click)="send()" >{{ 'COMMON.COMMON_OKEY_BUTTON' | translate }}</button>
        </div>
    </div>  
      </div>
    </div>

    <!-- Error popup -->
    <div class="popup-overlay" *ngIf="isErrorPopupVisible">
      <div class="popup-container">
        <div class="popup-header">
          <span class="popup-close" (click)="isErrorPopupVisible = false">×</span>
        </div>
        <div class="text-center logo-top">
          <div class="login-logo">
            <i class="warning"></i>
          </div>
          <div  class="text-center">
            <span class="err-text">エラー</span>
          </div>
          <div class="text-center">
            <p class="error-text-black" [innerHTML]="errorText"></p>
          </div>
        </div>
      </div>
    </div>

    <!-- Error Mail popup -->
    <div class="popup-overlay" *ngIf="isErrorMailPopupVisible">
      <div class="popup-container">
        <div class="popup-header">
          <span class="popup-close" (click)="isErrorMailPopupVisible = false">×</span>
        </div>
        <div class="text-center logo-top">
          <div class="login-logo">
            <i class="warning"></i>
          </div>
          <div  class="text-center">
            <span class="err-text">審査結果の再送信に失敗しました</span>
          </div>
          <div class="text-center">
            <p class="error-text-black" [innerHTML]="errorText"></p>
          </div>
        </div>
      </div>
    </div>

    
    <!-- Confirm popup -->
    <div class="popup-overlay" *ngIf="isConfirmPopupVisible">
      <div class="popup-container">
        <div class="popup-header">
          <span class="popup-title">{{ 'MAIL_ADDRESS.RE_CHANGE_MAIL_ADDRESS_CONFIRM' | translate }}</span>
          <span class="popup-close" (click)="isConfirmPopupVisible = false">×</span>
        </div>
        <div class="popup-underline"></div>
        <div class="text-center logo-top">
          <div class="text-center">
            <p class="error-text-black" [innerHTML]="errorText"></p>
          </div>
        </div>
        <div class="popup-actions">
          <button class="btn-cancel" (click)="isConfirmPopupVisible = false">{{ 'COMMON.COMMON_CLOSE' | translate }}</button>
        </div>
      </div>
    </div>

    <!-- Button -->
    <div class="text-center">
      <div class="two-btn">
        <div class="display">
          <a (click)="back()" class="btn-grey">{{ 'COMMON.COMMON_BACK_BUTTON' | translate }}
          </a>
        </div>
        <div class="display">
          <a (click)="edit()" class="btn-pink" *ngIf="wf_salecompany_contract_detail">{{ 'SALECOMPANY_LIST.MODIFY_BUTTON' | translate }}
          </a>
        </div>
      </div>
    </div>
    <!-- button end -->
  </section>
</div>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#E10800 " type = "square-jelly-box" [fullScreen] = "true">
  <p style="color: #E10800 " > {{ 'COMMON.LOADING' | translate }} </p>>
</ngx-spinner>
